module.exports = __webpack_public_path__ + "static/media/fantasyomatic-personas-persona-bill@2x.d7cae5e6.png";